export const timestampToShortLocaleDatestring = (
  timestamp: string,
  locale: string
) => {
  return new Date(timestamp).toLocaleDateString(locale, {
    weekday: 'short',
    day: 'numeric',
  })
}
